import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { NotificationService } from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import { NotificationsQuery } from 'projects/app-misc/src/app/modules/notification/data/notifications.query';
import { UserNotification } from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-mentions-column',
    templateUrl: './mentions-column.component.html',
    styleUrls: ['./mentions-column.component.scss']
})
@RxJSUnsubscribe
export class MentionsColumnComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
    @Input()
    notificationOP: OverlayPanel

    notifications: UserNotification[] = [];

    limit = 4;

    loadingg: boolean;

  wsSub: Subscription;
    constructor(
        protected notificationService: NotificationService,
        protected notificationQuery: NotificationsQuery,
        protected wsService: WsService) { }

    ngOnInit(): void {
        this.loadingg = true;
        this.updateNfs();
    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<UserNotification>>('/topic/update/model.notification.MentionNotification', this)
            .pipe(
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.updateNfs();
            })
    }

    updateNfs() {

        this.notificationService.getAllMentions().subscribe(page => {
            this.loadingg = false;
            this.notifications = page.content
        })
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }


}
